import { Box } from "@mui/material";
import { type ResponsiveStyleValue } from "@mui/system";
import { MOBILE_BREAKPOINT } from "@/styles/responsive";
import logo from "../../../assets/reassist_logo.svg";

/**
 * 置き場所ごとのロゴの高さ（px）。方針書 2-2 の表の値だけを使う。文字入りの版は 12px 未満にしない。
 */
export const REASSIST_LOGO_HEIGHT = {
  sideMenu: 14,
  pageHeader: { xs: 14, [MOBILE_BREAKPOINT]: 16 },
  mapLegend: 12,
  dialog: 14,
  serviceCard: { xs: 18, [MOBILE_BREAKPOINT]: 20 },
} as const;

interface Props {
  /** 高さ（px）。REASSIST_LOGO_HEIGHT の値を渡す。 */
  height: ResponsiveStyleValue<number>;
  /** 装飾として置く（読み上げでは別の要素がサービス名を伝える）ときは true。alt を空にする。 */
  decorative?: boolean;
}

/**
 * R.E.ASSIST のロゴ（SVG。ベクターのため、どの画面密度でも輪郭が崩れない）。
 * 図案と色は変えず、白地の上にだけ置く。
 */
export const ReassistLogo: React.FC<Props> = ({
  height,
  decorative = false,
}) => (
  <Box
    component="img"
    src={logo}
    alt={decorative ? "" : "R.E.ASSIST"}
    sx={{
      display: "block",
      height,
      width: "auto",
      maxWidth: "100%",
      flexShrink: 0,
    }}
  />
);
